<template>
  <div class="g-flex notice-box" @click="goNoticeList" v-if="readyFlag && list.length>0">
    <img src="@/assets/home/notice-icon.png" class="notice" alt="">
    <div class="g-full-width g-m-l-10">
      <el-carousel
                   direction="vertical"
                   arrow="never"
                   loop
                   indicator-position="none"
                   autoplay>
        <el-carousel-item v-for="(item,index) in list" :key="index">
          <p class="sub-text g-font-12">{{item.title}}</p>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
	import {noticeList} from "@/api/api.js"
export default {
  name: "notice-bar",
  data(){
    return{
		list:[],
		params:{
			current: 1,
			size: 10,
		},
		readyFlag: false
    }
  },
  mounted() {
	  if(this.$store.state.isLogin){
	  }
	  this.getNoticeList();
  },
  methods:{
	  getNoticeList() {
	  	noticeList(
	  		this.params
	  	).then(res => {
	  		this.list=res.records
	  		this.total=res.total
			this.readyFlag = true;
	  	})
	  },
    goNoticeList(){
      this.$router.push({
        name:'notice-list'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-box{
  padding: 6px 9px;
  background: #f6f6f8;
  border-radius: 5px;
  cursor: pointer;
}

  ::v-deep .el-carousel{
    height: 18px!important;
  }
  ::v-deep .el-carousel__container{
    height: 18px!important;
  }
</style>